const SUCCESS_SUFFIX = '_SUCCESS';
const FAILURE_SUFFIX = '_FAILURE';
const REQUEST_SUFFIX = '_REQUEST';
const RESET_SUFFIX = '_RESET';
const EVENT_SUFFIX = '_EVENT';

const DATA_KEY = 'data';
const ERROR_KEY = 'error';
const SUCCESS_KEY = 'success';
const FETCHING_KEY = 'fetching';
const FETCHING_COV_KEY = 'fetchingCov';

export default {
  SUCCESS_SUFFIX,
  FAILURE_SUFFIX,
  REQUEST_SUFFIX,
  RESET_SUFFIX,
  EVENT_SUFFIX,

  DATA_KEY,
  ERROR_KEY,
  SUCCESS_KEY,
  FETCHING_KEY,
  FETCHING_COV_KEY,
};
